import { axiosInstance } from "./axiosInstance";

export const categoryService = {
    getCategory: async ( filters ) => {
        return await axiosInstance.get('/api/superadmin/category', { params: filters })
    },
    createCategory: async (data) => {
        return await axiosInstance.post('/api/superadmin/category/create', data)
    },
    updateCategory: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/category/update/${id}`, data)
    },
    deleteCategory: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/category/delete/${id}`)
    }
}
